import React from "react";
import "./footer.css";
import logo from "../../images/edtech2.png";
import { TbWorld } from "react-icons/tb";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer py-5">
      <div className="container">
        <div className="row footer-row align-items-start text-center text-md-start justify-content-between">
          <div className="col-12 col-md-6 footer-col footer-brand-col">
            <div>
              <Link to="./" target="_blank">
                <img src={logo} width={150} alt="EdTech Ventures logo" />
              </Link>
            </div>

            <div className="footer-para my-3 mx-4 mx-md-0">
              We invest in and build AI-powered EdTech companies that close the
              gap between where talent is today and where the economy needs it
              to be — through skills-based learning and skills-based hiring
              infrastructure.
            </div>
          </div>

          <div className="col-12 col-md-4 footer-col footer-links-col">
            <h6 className="footer-headings">Quick Links</h6>
            <ul className="footer-links-list ps-0 mb-0">
              <li>
                <Link to="./" target="_blank">
                  Home
                </Link>
              </li>
              <li>
                <Link to="./team" target="_blank">
                  Team
                </Link>
              </li>
              <li>
                <Link to="./strategy" target="_blank">
                  Strategy
                </Link>
              </li>
              <li>Social Impact</li>
              <li>Careers</li>
            </ul>
          </div>
        </div>

        <hr />

        <div className="reserved-rights text-center">
          <TbWorld size={20} />
          &nbsp; <i>EdTech</i> Ventures. All Rights <i>Reserved</i>
        </div>
      </div>
    </div>
  );
};

export default Footer;